import React from "react";

function Personal({ stateObj, setStateObj, UpdateProfile, setCurrentDiv }) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Fullname</label>
          <input
            type="text"
            class="form-control"
            placeholder="Full Name"
            onChange={(e) =>
              setStateObj({ ...stateObj, fullname: e.target.value })
            }
            value={stateObj.fullname}
          ></input>
        </div>
      </div>
      {/* <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="marriedstatus">
            Married Status:
          </label>
          <select
            className="form-control"
            id="marriedstatus"
            name="married"
            onChange={(e) =>
              setStateObj({ ...stateObj, maritalstatus: e.target.value })
            }
            value={stateObj.maritalstatus}
          >
            <option value="">-- Select Marital Status --</option>
            <option value="single">Single</option>
            <option value="married">Married</option>
            <option value="widowed">Widowed</option>
            <option value="divorced">Divorced</option>
          </select>
        </div>
      </div> */}
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="mobile">
            Mobile:
          </label>
          <input
            className="form-control"
            id="mobile"
            name="mobile"
            mobile
            value={stateObj.mobile}
            readOnly
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label for="email">Email ID:</label>
          <input
            className="form-control"
            type="email"
            id="email"
            name="email"
            readOnly
            value={stateObj.email}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">City</label>
          <input
            type="text"
            class="form-control"
            placeholder="City"
            onChange={(e) => setStateObj({ ...stateObj, city: e.target.value })}
            value={stateObj.city}
          ></input>
        </div>
      </div>
      
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Region</label>
          <input
            type="text"
            class="form-control"
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe To Enter" : "Region"
            }
            readOnly={stateObj.activestatus !== "True"}
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, region: e.target.value });
            }}
            value={stateObj.region}
          ></input>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Pincode</label>
          <input
            type="text"
            class="form-control"
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Pincode"
            }
            readOnly={stateObj.activestatus !== "True"}
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, pincode: e.target.value });
            }}
            value={stateObj.pincode}
          ></input>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Country</label>
          <input
            type="text"
            class="form-control"
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe To Enter" : "Country"
            }
            readOnly={stateObj.activestatus !== "True"}
            onChange={(e) => {
              if (stateObj.activestatus === "True")
              setStateObj({ ...stateObj, country: e.target.value })
            }}
            value={stateObj.country}
          ></input>
        </div>
      </div>
      {/* <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label for="companySize">Experience:</label>
          <select
            id="experience"
            name="experience"
            onChange={(e) =>
              setStateObj({ ...stateObj, experience: e.target.value })
            }
            value={stateObj.experience}
            className="form-control"
          >
            <option value="">-- Select Experience --</option>
            <option value="experience">Experienced</option>
            <option value="fresher">Fresher</option>
          </select>
        </div>
      </div> */}
      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
            setCurrentDiv("education");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default Personal;
